import { SubmitPrequalResponseDto } from '@servicetitan/financing-api-client/src/prequals-api';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function usePrequalificationResponse() {
    const [prequalificationResponse, setPrequalificationResponse] =
        useState<SubmitPrequalResponseDto | null>(null);
    return { prequalificationResponse, setPrequalificationResponse };
}

export const PrequalificationResponseStore = createStore(usePrequalificationResponse);
export type PrequalificationResponseStore = ReturnType<typeof usePrequalificationResponse>;
